import { ButtonBase } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import { parseDate } from '@superdispatch/dates';
import { ColorDynamic, Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import { LoadDTO } from 'carrier/loads/data/LoadDTO';
import { DateTime } from 'luxon';
import { useState } from 'react';
import styled from 'styled-components';
import { LoadSuggestionsDrawer } from './LoadSuggestionsDrawer';
import { useLoadSuggestionsUnseenCountPerDriver } from './data/LoadSuggestionsAPI';
import { storeSelectedDrivers } from './data/LoadSuggestionsSelectedDriver';

const Container = styled(ButtonBase)`
  max-width: 288px;
  padding: 8px;
  border-radius: 4px;
  background-color: ${ColorDynamic.Blue50};
`;

const Count = styled.div`
  background-color: ${ColorDynamic.Blue300};
  border-radius: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  font-weight: 600;
  color: ${ColorDynamic.White};
`;

const ArrowIcon = styled(ArrowForwardIos)`
  margin: 4px;
  color: ${ColorDynamic.Dark100};
`;

function isWithinLast14DaysOrFuture(
  dateString: string | null | undefined,
): boolean {
  if (!dateString) return false;

  const date = parseDate(dateString);
  if (!date.isValid) return false;

  const now = DateTime.local();
  const fourteenDaysAgo = now.minus({ days: 14 });

  return date >= fourteenDaysAgo.startOf('day');
}

export function isValidLoadForSuggestedLoadsBanner(load: LoadDTO): boolean {
  const pickupDate = load.pickup.actual_date || load.pickup.scheduled_date;

  return (
    (load.stage === 'assigned' || load.stage === 'picked_up') &&
    isWithinLast14DaysOrFuture(pickupDate)
  );
}

interface Props {
  driverName: string;
  driverGuid: string;
  currentTab: string;
}

export function SuggestedLoadsPerDriverBanner({
  driverName,
  driverGuid,
  currentTab,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useLoadSuggestionsUnseenCountPerDriver(driverGuid);

  if (!data || data.number_of_unseen_suggestions === 0) {
    return null;
  }

  return (
    <>
      <LoadSuggestionsDrawer
        open={isOpen}
        source="Loads List"
        currentTab={currentTab}
        content="Suggested Loads for Driver Banner"
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <Container
        onClick={() => {
          storeSelectedDrivers([{ guid: driverGuid, name: driverName }]);
          setIsOpen(true);
        }}
      >
        <Inline verticalAlign="center" space="xxsmall" noWrap={true}>
          <Inline space="xsmall" verticalAlign="center">
            <Count>{data.number_of_unseen_suggestions}</Count>
            <Box width="212px">
              <TextBox noWrap={true} variant="body-semibold">
                Suggested loads for {driverName}
              </TextBox>
            </Box>
          </Inline>
          <ArrowIcon fontSize="small" />
        </Inline>
      </Container>
    </>
  );
}
